<template>
<div >
   <el-row class="table-grid-content">
			<el-col :span="3" >
				<el-input v-model="selecttypeName" placeholder="请输入机构名称"></el-input>
			</el-col>
			<el-col :span="3" class="grid" :gutter="1" style="margin-left:0.5rem;">
				<el-button type="success" @click="selectinit" icon="el-icon-search">搜索</el-button>
			</el-col>			
		</el-row>
  <el-table :data="purchaserecordsData" border style="width: 100%;margin-top: 1rem;">
    <el-table-column prop="orgId" label="机构ID"></el-table-column>
    <el-table-column prop="orgName" label="机构名称"></el-table-column>
    <el-table-column prop="typeName" label="类型名称"></el-table-column>
    <el-table-column prop="payType" label="付款方式" :formatter="payTypeFormat"></el-table-column>
    <el-table-column prop="payDate" label="付款时间"></el-table-column>
    <el-table-column prop="purchaseType" label="购买类型" :formatter="purchaseTypeFormat"></el-table-column>
    <el-table-column prop="purchaseNumber" label="数量" :formatter="purchaseNumberFormat"></el-table-column>
    <el-table-column prop="purchaseDuration" label="购买时长"></el-table-column>
    <el-table-column prop="purchasePrice" label="金额"></el-table-column>
    <el-table-column prop="orderNumber" label="订单号"></el-table-column>  
 </el-table>


  <el-pagination
    @size-change="sizeChange"
    @current-change="currentChange"
    :page-sizes="[10]"   
    :page-size="page.pageSize"
    layout="total, sizes, prev, pager, next"
    :total="page.totalRecords">
  </el-pagination>
  </div>

</template>

<script>
export default {
  data(){
    return{
      value:false,
      show:false,
       selecttypeName:"",
      purchaserecordsData:[],
      page:{
        pageSize: 10, //每页条数,  默认10条
        totalRecords: 0, //总条数
        totalPages: 0, //总页数
        pageNum:0
      },
       apiUrl:''  
    }
  },
  created(){
 this.apiUrl = localStorage.aipUrl
},

  mounted(){
    this.init();
   
  },
  methods:{
     payTypeFormat(row, column) {
    if (row.purchaseType === 2) {
      return '微信'
    } else  if(row.purchaseType===2){
      return '支付宝'
    }else  if(row.purchaseType===3){
      return '激活码'
    }else{
      return '其他'
    } 
  },
     purchaseTypeFormat(row, column) {
    if (row.purchaseType === 1) {
      return '按校区购买'
    } else  {
      return '按学员数购买'
    } 
  },
   purchaseNumberFormat(row, column) {
    if (row.purchaseType === 1) {
      return row.purchaseNumber+'校区'
    } else  {
      return row.purchaseNumber+'学员'
    } 
  },
   selectinit(){
      this.page.pageNum=0;
      this.init();
    },
    init(){
      this.purchaserecordsData=[];
      let {pageNum,pageSize}=this.page;
      this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageOrganizations/purchaseRecordsFind?`+(new Date()).valueOf(),
          data: {
            pageNum: this.page.pageNum,
            typeName: this.selecttypeName,
            pageSize: this.page.pageSize

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
            this.page.totalRecords=res.data.data.totalRecords; //总条数
            const studentArray=res.data.data.list;
            this.purchaserecordsData=studentArray;
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })
    

    },
    // 每页显示多少条数据
sizeChange(val) {
  this.page.pageSize = val;
  this.init();
},
//翻页
currentChange(val) {
  this.page.pageNum=val-1;
  console.log(this.page.pageNum);
  this.init();
},
  }
}
</script>
<style scoped>

.el-table /deep/ th{
    background-color: #EEEFF1;
}

</style>


// WEBPACK FOOTER //
// src/views/purchaseRecords.vue